<template>
  <!-- content-class="pSearch-Dialog" -->
  <v-dialog
    v-model="searchDialog"
    ref="searchDialog"
    max-width="400"
    @keydown.enter="pushEnter"
  >
    <v-card flat>
      <v-toolbar flat height="40px" :color="ColorGray2">
        <v-toolbar-title class="fs-m font-weight-bold pl-2"
        >検索条件</v-toolbar-title
        >
        <v-spacer></v-spacer>

        <v-btn icon small @click="searchDialog = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="pt-4">
        <div v-if="screen == 1" class="mb-4">
          <div class="fs-xs">商品</div>
          <v-select
            v-model="item"
            :items="shouhinKbnListSegment"
            outlined
            dense
            hide-details
          ></v-select>
        </div>

        <div class="mb-4">
          <div class="fs-xs">
            キーワード<Hint>
            <p>
              アルパカコネクトの納品作品・登録クリエイターを検索することができます。
            </p>
            <p class="mb-0">
              キーワードによる検索対象は以下の通りです

              <span class="font-weight-bold mt-2 d-block"
              >全体検索・イラスト・ボイス・ノベル</span
              >
              キャラクター名・ワールド名・商品名・タイトル（ノベル）・テーマ（ノベル）・台詞（ボイス）・クリエイター名
              <span class="font-weight-bold mt-2 d-block">クリエイター</span>
              クリエイター名
            </p>
          </Hint>
          </div>
          <v-text-field
            v-model="search"
            hide-details
            outlined
            dense
            placeholder="キーワード…"
          ></v-text-field>
        </div>

        <div class="mb-4" v-if="screen != 1">
          <div class="fs-xs">検索対象</div>
          <v-select
            v-model="searchType"
            :items="searchTypeList"
            placeholder="全体検索"
            outlined
            dense
            hide-details
            @change="changeSearchType"
          ></v-select>
        </div>

        <template v-if="!hideItemSegment">
          <div class="fs-xs fc-gray-6 d-flex align-center my-2">
            <div>作品セグメント</div>
            <v-divider class="ml-4"></v-divider>
          </div>

          <div class="mb-4">
            <div class="fs-xs">商品</div>

            <v-autocomplete
              v-model="item"
              :items="shouhinKbnListSegment"
              outlined
              dense
              chips
              small-chips
              hide-details
              multiple
              placeholder="全ての商品"
              no-data-text="商品の候補がありません"
            >
              <template v-slot:selection="{ item, parent, selected }">
                <v-chip
                  :color="ColorGray2"
                  :input-value="selected"
                  :id="'tag_' + item"
                  label
                  small
                >
                  <span>{{ item.text }}</span>
                  <v-icon right small @click.stop="parent.selectItem(item)"
                  >close</v-icon
                  >
                </v-chip>
              </template>
              <template v-slot:item="{ item }">
                <v-list-item-content>
                  <v-list-item-title>{{ item.text }}</v-list-item-title>
                </v-list-item-content>
              </template>
            </v-autocomplete>
          </div>

          <div class="mb-4">
            <div class="fs-xs">ワールド</div>
            <v-autocomplete
              v-model="world"
              :items="worldList"
              item-text="worldName"
              item-value="worldId"
              outlined
              dense
              chips
              small-chips
              hide-details
              placeholder="全てのワールド"
              multiple
              no-data-text="ワールドの候補がありません"
            >
              <template v-slot:selection="{ item, parent, selected }">
                <v-chip
                  :color="ColorGray2"
                  :input-value="selected"
                  :id="'tag_' + item"
                  label
                  small
                >
                  <span>{{ item.worldName }}</span>
                  <v-icon right small @click.stop="parent.selectItem(item)"
                  >close</v-icon
                  >
                </v-chip>
              </template>
              <template v-slot:item="{ item }">
                <v-list-item-content>
                  <v-list-item-title>{{ item.worldName }}</v-list-item-title>
                </v-list-item-content>
              </template>
            </v-autocomplete>
          </div>
        </template>

        <template v-if="!hideCreatorSegment && searchType === 'creator'">
          <div v-if="false" class="fs-xs fc-gray-6 d-flex align-center my-2">
            <div>クリエイターセグメント</div>
            <v-divider class="ml-4"></v-divider>
          </div>

          <!-- TODO:いずれマスターも追加 -->
          <div v-if="screen != 1" class="mb-4">
            <div class="fs-xs">ユーザークラス</div>
            <v-select
              v-model="userClass"
              :items="creatorKbnList"
              placeholder="全てのユーザークラス"
              outlined
              dense
              hide-details
            ></v-select>
          </div>

          <div class="mb-4">
            <div class="fs-xs">タグ</div>
            <v-autocomplete
              v-model="creatorTag"
              :items="creatorTagsSegment"
              item-text="tagName"
              item-value="tagCode"
              outlined
              dense
              chips
              small-chips
              hide-details
              multiple
              placeholder="全てのタグ"
              no-data-text="タグの候補がありません"
            >
              <template v-slot:selection="{ item, parent, selected }">
                <v-chip
                  :color="ColorGray2"
                  :input-value="selected"
                  :id="'tag_' + item"
                  label
                  small
                >
                  <span>{{ item.tagName }}</span>
                  <v-icon right small @click.stop="parent.selectItem(item)"
                  >close</v-icon
                  >
                </v-chip>
              </template>
              <template v-slot:item="{ item }">
                <v-list-item-content>
                  <v-list-item-title>{{ item.tagName }}</v-list-item-title>
                </v-list-item-content>
              </template>
            </v-autocomplete>
          </div>

          <div class="mb-4">
            <v-checkbox
              class="pt-0"
              v-model="likedCheck"
              hide-details=""
              outlined
              dense
              label="お気に入り"
            ></v-checkbox>
          </div>

          <div v-if="screen != 1" class="mb-4">
            <v-checkbox
              class="pt-0"
              v-model="openCheck"
              hide-details=""
              outlined
              dense
              label="受注中"
            ></v-checkbox>
          </div>

          <div class="mb-4" v-if="openCheck">
            <div class="fs-xs">受注中ワールド</div>
            <v-autocomplete
              v-model="openCheckWorld"
              :items="worldList"
              item-text="worldName"
              item-value="worldId"
              outlined
              dense
              chips
              small-chips
              hide-details
              placeholder="全てのワールド"
              multiple
              no-data-text="ワールドの候補がありません"
            >
              <template v-slot:selection="{ item, parent, selected }">
                <v-chip
                  :color="ColorGray2"
                  :input-value="selected"
                  :id="'tag_' + item"
                  label
                  small
                >
                  <span>{{ item.worldName }}</span>
                  <v-icon right small @click.stop="parent.selectItem(item)"
                  >close</v-icon
                  >
                </v-chip>
              </template>
              <template v-slot:item="{ item }">
                <v-list-item-content>
                  <v-list-item-title>{{ item.worldName }}</v-list-item-title>
                </v-list-item-content>
              </template>
            </v-autocomplete>
          </div>

          <div class="mb-4" v-if="openCheck && screen != 1">
            <div class="fs-xs">受注中商品</div>

            <v-autocomplete
              v-model="openCheckItem"
              :items="coShouhinKbnListSegment"
              outlined
              dense
              chips
              small-chips
              hide-details
              multiple
              placeholder="全ての商品"
              no-data-text="商品の候補がありません"
            >
              <template v-slot:selection="{ item, parent, selected }">
                <v-chip
                  :color="ColorGray2"
                  :input-value="selected"
                  :id="'tag_' + item"
                  label
                  small
                >
                  <span>{{ item.text }}</span>
                  <v-icon right small @click.stop="parent.selectItem(item)"
                  >close</v-icon
                  >
                </v-chip>
              </template>
              <template v-slot:item="{ item }">
                <v-list-item-content>
                  <v-list-item-title>{{ item.text }}</v-list-item-title>
                </v-list-item-content>
              </template>
            </v-autocomplete>
          </div>
        </template>

        <div class="row justify-center">
          <v-btn
            class="mb-2 fs-s fc-gray-8"
            width="180px"
            :loading="loading"
            text
            @click="clickReset()"
            :disabled="invalid"
          >検索条件リセット</v-btn
          >

          <v-btn
            class="mb-2"
            :loading="loading"
            color="primary"
            depressed
            block
            @click="goSearchResult"
            :disabled="invalid"
          >検索</v-btn
          >
          <v-btn
            :loading="loading"
            outlined
            depressed
            block
            :color="ColorTextSub"
            @click="searchDialog = false"
          >キャンセル</v-btn
          >
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
export default {
  name: "portalSearchDialog",
  props: {
    // 0:クリエイター検索、1:発注可能リストの場合
    screen: {
      mode: Number,
      required: false,
      default: 0,
    },

    //商品別検索
    type: {
      mode: String,
      required: false,
    },

    keyword: {
      mode: String,
      required: false,
      default: "",
    },
    creatorKbn: {
      mode: Number,
      required: false,
    },
    tags: {
      mode: Array,
      required: false,
    },
    liked: {
      mode: Boolean,
      default: false,
    },
    opend: {
      mode: Boolean,
      default: false,
    },
    ocItem: {
      mode: Array,
      required: false,
    },
    ocWorld: {
      mode: Array,
      required: false,
    },

    // shouhinKbnLists: {
    //   mode: Array,
    //   required: false,
    // },
    itemKbn: {
      mode: String,
      required: false,
      default: "",
    },
  },
  data() {
    return {
      searchDialog: false,
      loading: false,

      //キーワード
      search: "",

      searchType: "all",

      //作品セグメント
      item: [],
      world: [],

      //詳細検索
      searchTypeList: [
        { value: "all", text: "全体検索" },
        { value: "illust", text: "イラスト" },
        { value: "voice", text: "ボイス" },
        { value: "novel", text: "ノベル" },
        { value: "creator", text: "クリエイター" },
      ],

      //クリエイターセグメント
      userClass: 0,
      creatorTag: [],
      likedCheck: false,
      openCheck: false,

      openCheckItem: [],
      openCheckWorld: [],

      shouhinKbnList: [],
      worldList: [],
      creatorTagsList: [],

      //TODO:クリエイター種別
      creatorKbnList: [
        { value: 0, text: "全てのクリエイター" },
        { value: 1, text: "イラストレーター" },
        { value: 2, text: "ボイスアクター" },
        { value: 3, text: "ライター" },
        // { value: 4, text: "マスター" },
      ],
    };
  },

  watch: {
    //ダイアログが開かれた時に、現在の値を反映
    searchDialog() {
      if (this.searchDialog) {
        if (this.itemKbn) {
          this.item = this.itemKbn;
        } else {
          this.item = [];
        }
        if (this.keyword) {
          this.search = this.keyword;
        } else {
          this.search = "";
        }
        if (
          this.type == "illust" ||
          this.type == "novel" ||
          this.type == "voice" ||
          this.type == "creator"
        ) {
          this.searchType = this.type;
        } else {
          this.searchType = "all";
        }
        if (this.creatorKbn) {
          this.userClass = Number(this.creatorKbn);
        } else {
          this.userClass = 0;
        }
        if (this.tags) {
          this.creatorTag = this.tags.split(",");
        } else {
          this.creatorTag = [];
        }
        if (this.opend) {
          this.openCheck = this.opend;
        } else {
          this.openCheck = false;
        }
        if (this.liked) {
          this.likedCheck = this.liked;
        } else {
          this.likedCheck = false;
        }
        if (this.ocWorld) {
          this.openCheckWorld = this.ocWorld.split(",");
        } else {
          this.openCheckWorld = [];
        }
        if (this.ocItem) {
          this.openCheckItem = this.ocItem.split(",");
        } else {
          this.openCheckItem = [];
        }
      }
    },

    openCheck() {
      if (this.openCheck == false) {
        this.openCheckItem = [];
        this.openCheckWorld = [];
      }
    },
  },
  computed: {
    hideCreatorSegment() {
      return false;
    },

    //アイテム検索はいずれ実装
    hideItemSegment() {
      return true;
    },

    invalid() {
      // if (
      //   this.search != "" ||
      //   this.item != "" ||
      //   this.world != "" ||
      //   this.creatorTag != "" ||
      //   this.userClass != 0 ||
      //   this.openCheck === true ||
      //   this.likedCheck === true
      // ) {
      return false;
      // } else {
      //   return true;
      // }
    },

    selectItemType() {
      if (this.screen == 1 && this.shouhinKbnList.length > 0) {
        const result = this.shouhinKbnList.filter((v) => v.value === this.item);
        return result[0].type;
      }
    },

    //TODO:タグの使用フラグを取得して、タグ選択のselectitemをcreatorTagsSegmentに変更する
    //ユーザークラスセグメント時、またはタイプがボイス・ノベルの場合、発注可能クリエイターリストの場合はタグをセグメント
    creatorTagsSegment() {
      let result = this.creatorTagsList;
      //ノベルのみ
      if (
        this.userClass == 3 ||
        this.type == "novel" ||
        this.selectItemType == 3
      ) {
        result = this.creatorTagsList.filter(
          (v) => v.creator_kbn3_used === "1"
        );
      }
      //ボイスのみ
      else if (
        this.userClass == 2 ||
        this.type == "voice" ||
        this.selectItemType == 2
      ) {
        result = this.creatorTagsList.filter(
          (v) => v.creator_kbn2_used === "1"
        );
      }
      //イラストのみ
      else if (
        this.userClass == 1 ||
        this.type == "illust" ||
        this.selectItemType == 1
      ) {
        result = this.creatorTagsList.filter(
          (v) => v.creator_kbn1_used === "1"
        );
      }
      return result;
    },

    //タイプがボイス・ノベルの場合、選択できる商品をセグメントする
    shouhinKbnListSegment() {
      switch (this.type) {
        case "novel":
          return this.shouhinKbnList.filter((v) => v.type == "3");
          break;
        case "voice":
          return this.shouhinKbnList.filter((v) => v.type == "2");
          break;
        case "illust":
          return this.shouhinKbnList.filter((v) => v.type == "1");
          break;
        default:
          return this.shouhinKbnList;
          break;
      }
    },

    //ユーザークラスセグメント時は商品もセグメント
    coShouhinKbnListSegment() {
      switch (this.userClass) {
        case 3:
          return this.shouhinKbnList.filter((v) => v.type == "3");
          break;
        case 2:
          return this.shouhinKbnList.filter((v) => v.type == "2");
          break;
        case 1:
          return this.shouhinKbnList.filter((v) => v.type == "1");
          break;
        default:
          return this.shouhinKbnList;
          break;
      }
    },
  },
  methods: {
    open: async function () {
      const res = await axios({
        method: "get",
        url: this.serverPath + "/api/PortalSearch",
      });
      //フォロークリエイターセット
      this.shouhinKbnList = res.data.shouhinKbnListDto;
      this.worldList = res.data.worldNameDto;
      this.creatorTagsList = res.data.creatorTagInfoDto;

      this.searchDialog = true;
    },

    pushEnter(event) {
      // console.log(event.keyCode);
      if (event.keyCode === 13 && !this.invalid) {
        this.goSearchResult();
      }
    },

    //入力のリセット
    clickReset() {
      this.search = "";
      this.searchType = "all";
      this.changeSearchType();
    },

    changeSearchType() {
      if (this.screen != 1) {
        this.item = "";
      } else {
        this.item = this.itemKbn;
      }
      this.world = "";
      this.creatorTag = "";
      this.userClass = 0;
      if (this.screen != 1) {
        this.openCheck = false;
      }
      this.likedCheck = false;
      this.openCheckWorld = "";
      this.openCheckItem = "";
    },

    //キーワードが入力されている場合はparams付きで遷移
    goSearchResult() {
      const tags = this.creatorTag.join ? this.creatorTag.join(",") : "";
      const ocWorld = this.openCheckWorld ? this.openCheckWorld.join(",") : "";
      const ocItem = this.openCheckItem ? this.openCheckItem.join(",") : "";
      const search = this.search ? this.search : "";
      let name;
      switch (this.screen) {
        //　発注可能リストの場合
        case 1:
          if (search) {
            name = "ordermade-itemResult";
          } else {
            name = "ordermade-item";
          }
          break;
        //　アイテム検索
        case 2:
          if (search) {
            name = this.type + "Result";
          } else {
            name = this.type;
          }
          break;
        //　通常検索
        default:
          if (search) {
            name = "portalSearchResult";
          } else {
            name = "portalSearchResult-noWord";
          }
          break;
      }

      let query = {};

      if (tags) {
        this.$set(query, "tags", tags);
      }
      if (this.likedCheck) {
        this.$set(query, "liked", true);
      }
      if (this.openCheck && this.screen != 1) {
        this.$set(query, "opend", true);
      }
      if (ocWorld) {
        this.$set(query, "ocWorld", ocWorld);
      }
      if (ocItem) {
        this.$set(query, "ocItem", ocItem);
      }
      if (this.userClass && this.screen != 1) {
        this.$set(query, "creatorKbn", this.userClass);
      }

      const params =
        this.screen === 1
          ? { itemKbn: this.item, keyword: search }
          : { keyword: search, type: this.searchType };

      this.$router.push(
        {
          name: name,
          params: params,
          query: query,
        },
        () => {}
      );

      this.searchDialog = false;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/sass/import.scss";

.pSearch {
  ::v-deep &-Dialog {
    overflow-y: initial;
  }
}
</style>
